import { ElevionNode } from 'utils/elevion';

export const emptyVisibilityCondition = {
  logicalOp: 'AND',
  nodes: [
    {
      field: '',
      comparator: '==',
      value: '',
      field_type: 'sfield',
    },
  ],
} as ElevionNode;
